export default "__VITE_ASSET__DYRTgmra__"